import { http } from '@/api/http'
import type { ApiDetailedMenuResponse, ApiMenuResponse } from '@/api/types/menu'

export interface CustomMenuParams {
  RestaurantId?: string
  /** Только когда точки нет: с координатами регион сужает поиск зоны доставки */
  RegionId?: string
  Longitude?: string
  Latitude?: string
  OrderTypeId: number
}

/**
 * Три источника меню (§5 LOGIC.md): витрина региона, меню ресторана
 * и персональное меню по адресу — с ценами, доставкой и привязкой ресторана.
 */
export const menuService = {
  region: (regionId: string) => http.get<ApiMenuResponse>('/regionmenu', { RegionId: regionId }),
  restaurant: (restaurantId: string) =>
    http.get<ApiMenuResponse>('/restaurantmenu', { RestaurantId: restaurantId }),
  custom: (params: CustomMenuParams) => http.get<ApiDetailedMenuResponse>('/menu', { ...params }),
}
